module.exports = __webpack_public_path__ + "img/DW365-309.7cfdac14.jpg";